import stripUrlProtocol from 'utils/url/stripUrlProtocol';
import {INTEGRATION_NAME_APPROXIMATION_EQUALS} from 'utils/integrations/const';

/**
 * Given two objects, each of which represents an account integration. They are equal to each other iff:
 *
 * 1) integrationA.host == integrationB.host
 * 2) integrationA.name ~= integrationB.name
 *
 * Notice the ~= sign in #2 which indicates it's an approximation equal. This is necessary because the backend's
 * integration_data and crm_data do not share the same naming schema for the same kind of integrations. For example,
 * SFTPScraper and SFTPFileHandler should be considered equal iff their host is the same.
 *
 * @param integrationA {Object} Object with fields `host` and `name`
 * @param integrationB {Object} Object with fields `host` and `name`
 * @return equal {Bool} true if the 2 integrations are equal; false if not
 */
export default function integrationsAreEqual(integrationA, integrationB) {
  if (stripUrlProtocol(integrationA.host) === stripUrlProtocol(integrationB.host)) {
    return INTEGRATION_NAME_APPROXIMATION_EQUALS.some(
      approximationEquals =>
        approximationEquals.contains(integrationA.name) &&
        approximationEquals.contains(integrationB.name)
    );
  }
  return false;
}
